export default ({ value }) => Number(value) || 0;
